// Environment-aware SEO configuration for Vercel deployments
export const SEO_CONFIG = {
  // Determine if we're in production based on URL
  isProduction: () => {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname === 'prawnhub.xyz' || hostname === 'www.prawnhub.xyz';
  },
  
  // Check if we're on a Vercel preview deployment
  isPreview: () => {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname.includes('vercel.app') || hostname.includes('vercel.com');
  },
  
  // Check if we're in development
  isDevelopment: () => {
    if (typeof window === 'undefined') return false;
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  },
  
  // Get environment-specific robots directive
  getRobotsDirective: () => {
    if (SEO_CONFIG.isProduction()) {
      return 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
    }
    // Block indexing for preview and development
    return 'noindex, nofollow';
  },
  
  // Get environment-specific canonical URL
  getCanonicalUrl: (path = '') => {
    const apex = 'https://prawnhub.xyz';
    if (typeof window === 'undefined') return `${apex}${path}`;
    const current = window.location.hostname.toLowerCase();
    // Always force apex for production-like hosts (www or apex)
    if (current === 'prawnhub.xyz' || current === 'www.prawnhub.xyz') {
      return `${apex}${path}`;
    }
    return `${window.location.origin}${path}`;
  },
  
  // Should we include analytics?
  
  // Should we include social media meta tags?
  shouldIncludeSocialMeta: () => {
    return SEO_CONFIG.isProduction();
  },
  
  // Get environment-specific title suffix
  getTitleSuffix: () => {
    if (SEO_CONFIG.isPreview()) return ' [PREVIEW]';
    if (SEO_CONFIG.isDevelopment()) return ' [DEV]';
    return '';
  }
};

export default SEO_CONFIG;
